import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StateService } from './state.service';
import { UserService } from './user.service';
import { ToastrService } from 'ngx-toastr';
import { MatchBoardState } from '../store/state/reducers/matchboard.reducers';
import { Store } from '@ngrx/store';
import { InitState } from '../store/state/actions/matchboard.actions';
import { DataexchangeService } from './dataexchange.service';

@Injectable()
export class StateResolver implements Resolve<void> {
  constructor(
    private stateService: StateService,
    private userService: UserService,
    private toastr: ToastrService,
    private router: Router,
    private store: Store<MatchBoardState>,
    private readonly dataexchangeService: DataexchangeService,
  ) {}

  redirectToLogin() {
    localStorage.removeItem('currentUser');
    this.router.navigateByUrl('login');
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> | Promise<void> | void {
    return new Promise((resolve, reject) => {
      this.stateService
        .getState()
        .toPromise()
        .then((resp: any) => {
          const copy = {
            ...resp,
            isSuperUser: this.userService.isSuperUser(),
          };
          this.dataexchangeService.setTabs(resp.tabs);
          this.store.dispatch(new InitState(copy));
          resolve();
        })
        .catch((err) => {
          console.log(err);
          this.toastr.error(err.error);
          this.redirectToLogin();
          reject(err);
        });
    });
  }
}
